// ALL CONSTANTS

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';

//  CATALOGO

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const GET_PRODUCTS_SUCESS = 'GET_PRODUCTS_SUCESS';
export const GET_HOME_PRODUCTS = 'GET_HOME_PRODUCTS';
export const GET_HOME_PRODUCTS_ERROR = 'GET_HOME_PRODUCTS_ERROR';
export const GET_HOME_PRODUCTS_SUCCESS = 'GET_HOME_PRODUCTS_SUCCESS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const BUSQUEDA_CATALOGO = 'BUSQUEDA_CATALOGO';
export const OBTENER_CATALOGO = 'OBTENER_CATALOGO';
export const OBTENER_CATALOGO_ERROR = 'OBTENER_CATALOGO_ERROR';
export const OBTENER_CATALOGO_SUCCESS = 'OBTENER_CATALOGO_SUCCESS';
export const OBTENER_CATALOGO_BUSQUEDA = 'OBTENER_CATALOGO_BUSQUEDA';
export const OBTENER_CATALOGO_BUSQUEDA_ERROR =
   'OBTENER_CATALOGO_BUSQUEDA_ERROR';
export const OBTENER_CATALOGO_BUSQUEDA_SUCCESS =
   'OBTENER_CATALOGO_BUSQUEDA_SUCCESS';

//  LOGIN

export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';

export const RECUPERAR_PASSWORD = 'RECUPERAR_PASSWORD';
export const RECUPERAR_PASSWORD_ERROR = 'RECUPERAR_PASSWORD_ERROR';
export const RECUPERAR_PASSWORD_SUCCESS = 'RECUPERAR_PASSWORD_SUCCESS';

export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const VALIDATE_TOKEN_ERROR = 'VALIDATE_TOKEN_ERROR';
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';

export const CAMBIAR_PASSWORD = 'CAMBIAR_PASSWORD';
export const CAMBIAR_PASSWORD_ERROR = 'CAMBIAR_PASSWORD_ERROR';
export const CAMBIAR_PASSWORD_SUCCESS = 'CAMBIAR_PASSWORD_SUCCESS';

//  REGISTRO

export const SIGNIN = 'SIGNIN';
export const SIGNIN_ERROR = 'SIGNIN_ERROR';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';

//  CARRITO

export const AGREGAR_CARRITO = 'AGREGAR_CARRITO';
export const AGREGAR_CARRITO_ITEM = 'AGREGAR_CARRITO_ITEM';
export const GUARDAR_DIRECCION = 'GUARDAR_DIRECCION';
export const CREAR_PEDIDO = 'CREAR_PEDIDO';
export const CREAR_PEDIDO_ERROR = 'CREAR_PEDIDO_ERROR';
export const CREAR_PEDIDO_SUCCESS = 'CREAR_PEDIDO_SUCCESS';
export const PROCESAR_CARGO = 'PROCESAR_CARGO';
export const PROCESAR_CARGO_ERROR = 'PROCESAR_CARGO_ERROR';
export const PROCESAR_CARGO_SUCCESS = 'PROCESAR_CARGO_SUCCESS';
export const QUITAR_CARRITO = 'QUITAR_CARRITO';

//  DIRECCIONES

export const OBTENER_DIRECCIONES = 'OBTENER_DIRECCIONES';
export const OBTENER_DIRECCIONES_ERROR = 'OBTENER_DIRECCIONES_ERROR';
export const OBTENER_DIRECCIONES_SUCCESS = 'OBTENER_DIRECCIONES_SUCCESS';

//  CHECKOUT

export const CHECK_PRICES = 'CHECK_PRICES';
export const CHECK_PRICES_ERROR = 'CHECK_PRICES_ERROR';
export const CHECK_PRICES_SUCCESS = 'CHECK_PRICES_SUCCESS';
export const CHECKOUT = 'CHECKOUT';
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';

//  PAGOS

export const PROCESAR_PAGO = 'PROCESAR_PAGO';
export const PROCESAR_PAGO_ERROR = 'PROCESAR_PAGO_ERROR';
export const PROCESAR_PAGO_SUCCESS = 'PROCESAR_PAGO_SUCCESS';

//  COUNTRIES AND STATES
export const OBTENER_ESTADOS = 'OBTENER_ESTADOS';
export const OBTENER_ESTADOS_ERROR = 'OBTENER_ESTADOS_ERROR';
export const OBTENER_ESTADOS_SUCCESS = 'OBTENER_ESTADOS_SUCCESS';
export const OBTENER_PAISES = 'OBTENER_PAISES';
export const OBTENER_PAISES_ERROR = 'OBTENER_PAISES_ERROR';
export const OBTENER_PAISES_SUCCESS = 'OBTENER_PAISES_SUCCESS';

//  PEDIDOS
export const OBTENER_PEDIDOS = 'OBTENER_PEDIDOS';
export const OBTENER_PEDIDOS_ERROR = 'OBTENER_PEDIDOS_ERROR';
export const OBTENER_PEDIDOS_SUCCESS = 'OBTENER_PEDIDOS_SUCCESS';
export const OBTENER_PEDIDOS_LINEAS = 'OBTENER_PEDIDOS_LINEAS';
export const OBTENER_PEDIDOS_LINEAS_ERROR = 'OBTENER_PEDIDOS_LINEAS_ERROR';
export const OBTENER_PEDIDOS_LINEAS_SUCCESS = 'OBTENER_PEDIDOS_LINEAS_SUCCESS';
export const CLEAN_CART = 'CLEAN_CART';

// MAPAS
export const CANCUN_MAP_URL =
   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1860.2059621523345!2d-86.82752416321384!3d21.175789200000015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2d1e2f9640f3%3A0xb07370bad57f9861!2sExpo%20M%C3%A9dica!5e0!3m2!1ses-419!2smx!4v1692205605280!5m2!1ses-419!2smx';

export const CANCUN_MAP_URL2 =
   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14883.398163500991!2d-86.84618794458008!3d21.158385200000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2bf8be656d33%3A0x1e86167a3d40fd60!2sExpo%20M%C3%A9dica!5e0!3m2!1ses!2smx!4v1692630873640!5m2!1ses!2smx';

export const PLAYA_DEL_CARMEN_MAP_URL =
   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1867.042237360726!2d-87.08645635557251!3d20.6254133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4e4340e8c5c4d3%3A0x9cc82a17fb66c7b6!2sExpo%20Medica!5e0!3m2!1ses-419!2smx!4v1692205687331!5m2!1ses-419!2smx';

export const VERSION = 'VERSION';



// WEBPACK FOOTER //
// ./src/redux/constants.js